// src/components/NotAdmin.js
import React from 'react';
import { signOut } from 'firebase/auth'; // Import the function to sign out
import { auth } from '../firebase'; // Import the initialized Firebase authentication instance
import '../App.css'; // 

const NotAdmin = ({ user, setUser }) => {
    // Handler for logging out the user
    const handleLogout = () => {
        signOut(auth)
            .then(() => {
                // Clear the user state on successful logout
                setUser(null); 
            })
            .catch((error) => {
                // Log any errors that occur during logout
                console.error('Error logging out: ', error); 
            });
    };

    // console.log('User:', user);


    return (
        <div className="App-header">
            {/* Display the user's username if available */}
            {user && user.username && <h2>Welcome, {user.fullName}</h2>}
            {/* Display a message indicating the user does not have admin permissions */}
            <p>You do not have permission to access this page.</p>

            {/* Button to log out */}
            <button onClick={handleLogout}>Logout</button>
        </div>
    );
};

export default NotAdmin;
